import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';

const changePassRoutes: Routes = [
  { path: '', component: ChangePasswordComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(changePassRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class ChangePassRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/change-password/change-password.routing.ts